import {
    listViewStore,
    shouldSuppressServerMarkReadOnReplyOrForward,
    MailRowDataPropertyGetter,
    TableQueryType,
} from 'owa-mail-list-store';
import {
    lazyReplyToItem,
    lazyReplyToConversation,
    lazyForwardConversation,
    lazyForwardItem,
} from 'owa-mail-message-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import shouldShowUnstackedReadingPane from 'owa-mail-store/lib/utils/shouldShowUnstackedReadingPane';
import { ActionSource } from 'owa-analytics-actions';

export const enum ResponseType {
    Reply,
    ReplyAll,
    Forward,
}

export function onReply(actionSource: ActionSource) {
    onResponse(ResponseType.Reply, actionSource);
}

export function onReplyAll(actionSource: ActionSource) {
    onResponse(ResponseType.ReplyAll, actionSource);
}

export function onForward(actionSource: ActionSource) {
    onResponse(ResponseType.Forward, actionSource);
}

function onResponse(responseType: ResponseType, actionSource: ActionSource) {
    const tableViewId = listViewStore.selectedTableViewId;
    const tableView = listViewStore.tableViews.get(tableViewId)!;
    const rowKey = [...tableView.selectedRowKeys.keys()][0];
    const rowId = MailRowDataPropertyGetter.getRowIdToShowInReadingPane(rowKey, tableView);
    const suppressServerMarkReadOnReplyOrForward = shouldSuppressServerMarkReadOnReplyOrForward(
        tableView
    );
    let instrumentationContexts;
    if (tableView.tableQuery.type == TableQueryType.Search) {
        instrumentationContexts = getInstrumentationContextsFromTableView([rowKey], tableView);
    }
    const listViewType = tableView.tableQuery.listViewType;

    if (responseType === ResponseType.Reply || responseType === ResponseType.ReplyAll) {
        if (listViewType === ReactListViewType.Message || shouldShowUnstackedReadingPane()) {
            lazyReplyToItem.importAndExecute(
                rowId,
                responseType === ResponseType.ReplyAll,
                actionSource,
                instrumentationContexts,
                suppressServerMarkReadOnReplyOrForward
            );
        } else if (listViewType === ReactListViewType.Conversation) {
            lazyReplyToConversation.importAndExecute(
                rowId,
                responseType === ResponseType.ReplyAll,
                actionSource,
                instrumentationContexts,
                suppressServerMarkReadOnReplyOrForward
            );
        }
    } else {
        // responseType === ResponseType.Forward
        if (listViewType === ReactListViewType.Message || shouldShowUnstackedReadingPane()) {
            lazyForwardItem.importAndExecute(
                rowId,
                actionSource,
                instrumentationContexts,
                suppressServerMarkReadOnReplyOrForward
            );
        } else if (listViewType === ReactListViewType.Conversation) {
            lazyForwardConversation.importAndExecute(
                rowId,
                actionSource,
                instrumentationContexts,
                suppressServerMarkReadOnReplyOrForward
            );
        }
    }
}
